import { ScreenName } from '@helpcenter/constants';
import { Login } from 'view/login';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';
import { anonymousScreenLayout, PORTAL_ROUTE_PREFIX, LOGIN_ROUTE } from '../common/constants';

const portalLogin = {
    name: 'portal-login',
    path: `${PORTAL_ROUTE_PREFIX}/user/login`,
    exact: true,
    component: Login,
    resources: [],
};

const login = {
    name: 'login',
    path: LOGIN_ROUTE,
    exact: true,
    component: Login,
    resources: [],
};

const screenName = ScreenName.LOGIN;

export const loginRoute = createRouteWithLayout(login, screenName, anonymousScreenLayout);
export const portalLoginRoute = createRouteWithLayout(portalLogin, screenName, anonymousScreenLayout);
